import React, { Fragment, type FunctionComponent } from 'react'
import { useSelectOptionsDashMessage } from 'domains/banners/utils/intl.hooks'
import { BannerLocaleEnum } from 'domains/banners/api'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { MerchandisingFormInput } from 'domains/merchandising/components/form-input/MerchandisingFormInput'
import { MerchandisingFormTextArea } from 'domains/merchandising/components/form-input/MerchandisingFormTextArea'
import { MerchandisingFormSelect } from 'domains/merchandising/components/form-input/MerchandisingFormSelect'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { localeOptions } from 'domains/banners/constants/banner.constants'

interface Props extends Omit<ControllerProps, 'name'> {}

export const FlyoutFormContentText: FunctionComponent<Props> = ({ form }) => {
  const { register, getValues, setValue, errors } = form

  return (
    <Fragment>
      <input
        type="hidden"
        value={getValues('titleText.color') || '#333333'}
        name="titleText.color"
        ref={register}
      />

      <input
        type="hidden"
        value={getValues('descriptionText.color') || '#333333'}
        name="descriptionText.color"
        ref={register}
      />

      <input
        type="hidden"
        value={getValues('disclaimerText.color') || '#333333'}
        name="disclaimerText.color"
        ref={register}
      />

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormSelect
            form={form}
            labelId="bannersDomain.flyoutForm.form.locale.label"
            identifier={'locale'}
            onChange={selectedOption => setValue('locale', selectedOption.value)}
            options={useSelectOptionsDashMessage(localeOptions)}
            defaultValue={BannerLocaleEnum.EnUs}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="titleText.text"
            ref={register({ required: true })}
            defaultValue={getValues('titleText.text')}
            labelId="bannersDomain.bannersForm.form.section.content.title.label"
            maxLength={62}
            errors={errors}
            showLength
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormTextArea
            identifier="descriptionText.text"
            ref={register({ required: true })}
            defaultValue={getValues('descriptionText.text')}
            labelId="bannersDomain.bannersForm.form.section.content.description.label"
            maxLength={250}
            showLength
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="disclaimerText.text"
            ref={register({ required: false })}
            defaultValue={getValues('disclaimerText.text')}
            labelId="bannersDomain.bannersForm.form.section.content.disclaimer.label"
            maxLength={62}
            errors={errors}
            showLength
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
    </Fragment>
  )
}
